import * as s from "../LoginStyled";
import { Validate, ValidateMsg } from "api/interfaces/commonInterface.interface";

import {
  LOGIN_STEP,
  LoginInfo,
} from "../LoginContainer";
import InputEmailForm from "../mydw/email/InputEmailForm";
import { UnderlineText } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import BigButton from "components/atoms/buttons/BigButton";
import {
  RESELLER_CHECK_STEP,
  ResellerInfo,
  RESSELLER_USER_TYPE,
} from "api/interfaces/authInterface.interface";
import AccountId from "components/atoms/text/labels/AccountId";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";

interface Props {
  //   loading: boolean;
  loginInfo: LoginInfo;
  isValidated: Validate;
  validateMsg: ValidateMsg;
  onChangeLoginInfo: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleClick: () => void;
  onClickGoBack: () => void;
  type: RESELLER_CHECK_STEP;
  onClickSignUp: () => void;
  userType: RESSELLER_USER_TYPE;
  resellerInfo: ResellerInfo;
}
const CheckedEmail = {
  [RESSELLER_USER_TYPE.NOT_SALESFORCE_USER]: {
    title: (
      <h3>
        This email address is not registered
        <span className="inline-block">as a DW Partner</span>
      </h3>
    ),

    description: "Would you like to become a Channel Partner?",
    buttonLabel: "Becoming a Channel Partner",
  },
  [RESSELLER_USER_TYPE.SALESFORCE_USER]: {
    title: (
      <h3>
        This email address is registered{" "}
        <span className="inline-block">as a DW Partner</span>
      </h3>
    ),

    description: "Wolud you like to sign up for myDW with this email address?",
    buttonLabel: "Sign up for myDW",
  },
  [RESSELLER_USER_TYPE.MYDW_USER]: {
    title: <h3>Your email address is already registered with myDW</h3>,
    description: "Would you like to try logging in with this email address?",
    buttonLabel: "Login",
  },
  [RESSELLER_USER_TYPE.HAS_ORG]: {
    title: <h3>Your company is already registered in myDW</h3>,
    description:
      "Please request an invitation from your company administrator.",
    buttonLabel: "Login",
  },
};
export default function ResellerPresenter({
  //   loading,
  loginInfo,
  isValidated,
  validateMsg,
  onChangeLoginInfo,
  handleClick,
  onClickGoBack,
  type,
  onClickSignUp,
  userType,
  resellerInfo,
}: Props) {
  return (
    <s.ResellerCheckedEmailWrapper>
      {type === RESELLER_CHECK_STEP.CHECK_EMAIL && (
        <>
          <h3>
            Make sure your email address is registered on DW's reseller list
          </h3>
          <InputEmailForm
            loginInfo={loginInfo}
            isValidated={isValidated}
            validateMsg={validateMsg}
            onChangeLoginInfo={onChangeLoginInfo}
            handleClick={handleClick}
          />
        </>
      )}

      {type === RESELLER_CHECK_STEP.CHECKED_EMAIL && CheckedEmail[userType] && (
        <>
          {CheckedEmail[userType].title}
          <p className="description">{CheckedEmail[userType].description}</p>
          {userType === RESSELLER_USER_TYPE.HAS_ORG ? (
            <>
              {resellerInfo.companyName}
              <AccountId level={LEVEL_TYPE.CP} accountId={resellerInfo.cppNo} />
            </>
          ) : (
            <s.EmailBadge>{loginInfo.email}</s.EmailBadge>
          )}

          <BigButton
            label={CheckedEmail[userType].buttonLabel}
            onClickBtn={onClickSignUp}
            className="reseller-sign-up"
            data-testid="auth-signin-reseller-button-click-sign-up"
          />
        </>
      )}

      <s.Bottom center>
        <UnderlineText
          id="dw_login_button_forward_email"
          fontSize={14}
          color={COLORS.BUTTONS1}
          onClick={onClickGoBack}
          data-testid="auth-signin-reseller-forward-email-click-go-back"
        >
          Go Back
        </UnderlineText>
      </s.Bottom>
    </s.ResellerCheckedEmailWrapper>
  );
}
